import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseSource } from "../BaseSource";
/**
 * @memberOf Qualifiers.Source
 * @extends {Qualifiers.Source.BaseSource}
 * @description Defines how to manipulate an image layer
 * <div class="panel panel-warning">
 *   <div class="panel-heading">Notice</div>
 *   <div class="panel-body">
 *     This class is used as a Qualifier for the asset.overlay() and asset.underlay() methods.</br>
 *     You can find regular images and videos transformations below:
 *   </div>
  *   <ul>
 *     <li>{@link SDK.ImageTransformation| Image Transformations}</li>
 *     <li>{@link SDK.VideoTransformation| Video Transformations}
 *   </ul>
 * </div>
 */

var ImageSource = /*#__PURE__*/function (_BaseSource) {
  _inherits(ImageSource, _BaseSource);

  var _super = _createSuper(ImageSource);

  function ImageSource(publicID) {
    var _this;

    _classCallCheck(this, ImageSource);

    _this = _super.call(this);
    _this._publicID = publicID;
    return _this;
  }
  /**
   * @description
   * Returns the opening string of the layer,
   * This method is used internally within {@link SDK.LayerAction|LayerAction}
   * @returns {string}
   */


  _createClass(ImageSource, [{
    key: "getOpenSourceString",
    value: function getOpenSourceString(layerType) {
      var encodedPublicID = this.encodeAssetPublicID(this._publicID);

      if (this._format) {
        return "".concat(layerType, "_").concat(encodedPublicID, ".").concat(this._format.toString());
      } else {
        return "".concat(layerType, "_").concat(encodedPublicID);
      }
    }
    /**
     * @description
     * Apply a format for the image source of the layer
     * @param {FormatQualifier} format A to apply to the layered image, see more {@link Qualifiers.Format|here}
     * @returns {this}
     */

  }, {
    key: "format",
    value: function format(_format) {
      this._format = _format;
      return this;
    }
  }]);

  return ImageSource;
}(BaseSource);

export { ImageSource };